(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('card-carousel')) {
    customElements.define('card-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        if (!this.track) return;
        this.controls = this.querySelector('[data-carousel-controls]');
        this.onClick = event => {
          const control = event.target.closest('[data-carousel-direction]');
          if (control && this.contains(control)) this.move(control.dataset.carouselDirection === 'next' ? 1 : -1);
        };
        this.onKeydown = event => {
          if (event.target !== this.track) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') {
            this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.endPosition(), behavior: this.scrollBehavior() });
          } else {
            this.move(event.key === (this.isRTL() ? 'ArrowLeft' : 'ArrowRight') ? 1 : -1);
          }
        };
        this.onScroll = () => this.updateControls();
        this.onBlockSelect = event => {
          const card = event.target.closest('[data-carousel-card]');
          if (!card || !this.contains(card)) return;
          const cardBounds = card.getBoundingClientRect();
          const trackBounds = this.track.getBoundingClientRect();
          const offset = this.isRTL() ? cardBounds.right - trackBounds.right + 4 : cardBounds.left - trackBounds.left - 4;
          this.track.scrollTo({ left: this.track.scrollLeft + offset, behavior: 'auto' });
        };
        this.addEventListener('click', this.onClick);
        this.track.addEventListener('keydown', this.onKeydown);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(this.track);
        this.updateControls();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.track?.removeEventListener('keydown', this.onKeydown);
        this.track?.removeEventListener('scroll', this.onScroll);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver?.disconnect();
      }
      isRTL() { return getComputedStyle(this.track).direction === 'rtl'; }
      endPosition() { return (this.track.scrollWidth - this.track.clientWidth) * (this.isRTL() ? -1 : 1); }
      scrollBehavior() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
      move(direction) {
        const card = this.track.querySelector('[data-carousel-card]');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = card.getBoundingClientRect().width + gap;
        this.track.scrollBy({ left: step * direction * (this.isRTL() ? -1 : 1), behavior: this.scrollBehavior() });
      }
      updateControls() {
        if (!this.controls) return;
        const overflow = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        this.controls.hidden = overflow <= 2;
        this.controls.querySelector('[data-carousel-direction="previous"]').disabled = position <= 2;
        this.controls.querySelector('[data-carousel-direction="next"]').disabled = position >= overflow - 2;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-pagination"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collection-pagination')) {
    customElements.define('collection-pagination', class extends HTMLElement {
      connectedCallback() {
        this.onClick = this.onClick || this.loadMore.bind(this);
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.controller?.abort();
      }

      async loadMore(event) {
        const button = event.target.closest('[data-load-more]');
        if (!button || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (this.loading) return;
        const grid = this.closest('[data-section-type="collection-section"]').querySelector('#main-collection-product-grid');
        const status = this.querySelector('[data-load-status]');
        const label = button.querySelector('.link-button__label');
        const idleLabel = label.textContent;
        const url = new URL(button.href);
        url.searchParams.set('section_id', this.dataset.sectionId);
        this.controller = new AbortController();
        const requestTimeout = setTimeout(() => this.controller.abort(), 30000);
        this.loading = true;
        button.setAttribute('aria-disabled', 'true');
        grid.setAttribute('aria-busy', 'true');
        label.textContent = this.dataset.loadingLabel;
        status.textContent = '';

        try {
          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) throw new Error('Request failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (!this.isConnected) return;
          const nextControls = html.querySelector('collection-pagination');
          const nextGrid = html.querySelector('#main-collection-product-grid');
          if (!nextControls || !nextGrid) throw new Error('Missing collection');
          const products = Array.from(nextGrid.querySelectorAll(':scope > .product-index'));
          if (!products.length) throw new Error('Missing products');
          const knownProducts = new Set(Array.from(grid.querySelectorAll(':scope > .product-index')).map(item => item.dataset.productId));
          const newProducts = products.filter(item => !knownProducts.has(item.dataset.productId));
          grid.append(...newProducts);
          this.dataset.rangeEnd = nextControls.dataset.rangeEnd;
          this.dataset.total = nextControls.dataset.total;
          this.querySelector('[data-product-range]').textContent = this.dataset.rangeTemplate
            .replace('__start__', this.dataset.rangeStart)
            .replace('__end__', this.dataset.rangeEnd)
            .replace('__total__', this.dataset.total);
          this.querySelector('.collection-pagination__pages').replaceChildren(...nextControls.querySelector('.collection-pagination__pages').childNodes);
          const nextButton = nextControls.querySelector('[data-load-more]');
          if (nextButton) {
            button.href = nextButton.href;
            status.textContent = this.dataset.loadedTemplate.replace('__count__', newProducts.length);
          } else {
            if (document.activeElement === button) newProducts[0]?.querySelector('a[href]')?.focus({ preventScroll: true });
            button.hidden = true;
            status.textContent = this.dataset.allLoaded;
          }
          newProducts.forEach(product => window.Shopify?.theme?.quickview?.init(product));
          window.WAU?.ProductGridVideo?.init();
          window.AOS?.refreshHard();
        } catch (error) {
          if (this.isConnected) status.textContent = this.dataset.loadError;
        } finally {
          clearTimeout(requestTimeout);
          this.loading = false;
          button.removeAttribute('aria-disabled');
          grid.removeAttribute('aria-busy');
          label.textContent = idleLabel;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
